import { jsxs as e, jsx as o } from "react/jsx-runtime";
import { FoamLogo as t } from "../../../atoms/FoamLogo/FoamLogo.es.js";
import { Paragraph as m } from "../../../atoms/Paragraph/Paragraph.es.js";
import { chakra as s } from "@chakra-ui/react";
import { useSharedFooterStyle as a } from "../SharedFooter.context.es.js";
const d = () => {
  const r = a();
  return /* @__PURE__ */ e(s.a, { __css: r.logo, href: "https://www.foam.io/verified", target: "_blank", children: [
    /* @__PURE__ */ o(m, { size: "sm", children: "Powered by" }),
    " ",
    /* @__PURE__ */ o(t, {})
  ] });
};
export {
  d as SharedFooterLogo
};
//# sourceMappingURL=SharedFooterLogo.es.js.map
